import { render, staticRenderFns } from "./statementDetail.vue?vue&type=template&id=ad8e372e&scoped=true"
import script from "./statementDetail.vue?vue&type=script&lang=js"
export * from "./statementDetail.vue?vue&type=script&lang=js"
import style0 from "./statementDetail.vue?vue&type=style&index=0&id=ad8e372e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8e372e",
  null
  
)

export default component.exports